/* eslint-disable @typescript-eslint/no-explicit-any */
import { SortingFnOption } from "@tanstack/react-table";
import { HeaderDef } from "@/types/table";

export const getColumns = <TData>(headers: HeaderDef<TData>[]) =>
  headers.map((h) => ({
    ...h,
    sortingFn: "alphanumericNullLast" as SortingFnOption<TData>,
    accessorFn: (data: any) => data[h.accessorKey],
  }));

// only show table footer if visible columns have footers
export const hasVisibleFooter = <TData>(columns: HeaderDef<TData>[]) =>
  columns.some((col) => col.footer && !col.hidden);
